import { trackLanguage } from '@leprecoins/effector-i18next';
import { createEvent } from 'effector';
import { i18next } from '../i18next';

const setup = createEvent();

trackLanguage({ setup, instance: i18next });

export const language = { setup };
